import { Component, OnInit } from '@angular/core';
import { PermissionStorageService } from 'src/app/authentication/storages/permission-storage.service';
import { ExpenseService } from '../services/expense.service';
import { ExpenseStoreService } from '../storage/expense-store.service';
import { EXPENSES_ACCOUNTING_PERMISSION } from '../models/expense';

@Component({
    selector: 'app-expenses',
    templateUrl: './expenses.component.html',
    standalone: false
})
export class ExpensesComponent implements OnInit {

  // The review and "all expenses" tabs are shown whenever the user has a supervisor/HR function,
  // regardless of whether anything is currently pending. Hidden for employees without that function.
  canReview = false;

  // Accounting users get their own "Buchhaltung" tab (payment run: filter, export, mark paid).
  // It does not depend on canReview - a pure accounting user sees only "Meine Spesen" and it.
  hasAccounting = (this.permissionStorage.getPermissions() ?? [])
    .includes(EXPENSES_ACCOUNTING_PERMISSION);

  // The tabstrip renders only once canReview is resolved, so all tabs are evaluated in a single
  // render pass - Kendo's TabStrip does not reliably pick up a tab added asynchronously via *ngIf.
  ready = false;

  // Number of expenses still to review (badge on the "Zu prüfen" tab).
  reviewCount$ = this.expenseStore.toReviewCount$;

  constructor(
    private expenseService: ExpenseService,
    private expenseStore: ExpenseStoreService,
    private permissionStorage: PermissionStorageService
  ) { }

  ngOnInit(): void {
    // Only the boolean tab-visibility check is needed up front. The per-tab lists load lazily via
    // Kendo's tab content (rendered only when a tab is selected). The review badge count is already
    // maintained app-wide (see AppComponent) and refreshed when the review tab opens / after a
    // decision, so it must not be re-fetched here — that would hit the approval endpoint while the
    // user is still on the "Meine Spesen" tab.
    this.expenseService.canReviewExpenses().subscribe({
      next: can => {
        this.canReview = can;
        this.ready = true;
      },
      error: () => this.ready = true
    });
  }
}
